export const defaultScopeType = scopeMode => {
  if (scopeMode === "global") return "global";
  if (scopeMode === "self" || scopeMode === "self_or_facility") return "self";
  return "home_store";
};

export const scopeOptions = scopeMode => {
  if (scopeMode === "global") return [{ value:"global",label:"全体" }];
  if (scopeMode === "self") return [{ value:"self",label:"本人のみ" }];
  const facilityOptions = [
    { value:"home_store",label:"所属施設" },
    { value:"selected_stores",label:"選択した施設" },
    { value:"all_stores",label:"全施設" },
  ];
  return scopeMode === "self_or_facility"
    ? [{ value:"self",label:"本人のみ" },...facilityOptions]
    : facilityOptions;
};

export function buildPermissionDraft(permissions, grants = []) {
  const current = new Map(grants.map(grant => [grant.permission_key, grant]));
  return Object.fromEntries(permissions.map(permission => {
    const grant = current.get(permission.permission_key);
    return [permission.permission_key, {
      permission_key: permission.permission_key,
      allowed: Boolean(grant?.allowed),
      scope_type: grant?.scope_type || defaultScopeType(permission.scope_mode),
      store_ids: [...(grant?.store_ids || [])].sort(),
    }];
  }));
}

export function applyTemplateToDraft(permissions, template) {
  const items = new Map((template?.items || []).map(item => [item.permission_key,item]));
  return Object.fromEntries(permissions.map(permission => {
    const item = items.get(permission.permission_key);
    return [permission.permission_key, {
      permission_key: permission.permission_key,
      allowed: Boolean(item),
      scope_type: item?.scope_type || defaultScopeType(permission.scope_mode),
      store_ids: [],
    }];
  }));
}

export function applyBulkFacilityScope(draft, permissions, scopeType, storeIds = []) {
  const facilityModes = new Set(["facility","self_or_facility"]);
  return Object.fromEntries(Object.entries(draft).map(([key,value]) => {
    const permission = permissions.find(item => item.permission_key === key);
    if (!value.allowed || !facilityModes.has(permission?.scope_mode)) return [key,value];
    return [key,{
      ...value,
      scope_type: scopeType,
      store_ids: scopeType === "selected_stores" ? [...storeIds].sort() : [],
    }];
  }));
}

export const serializePermissionDraft = (permissions, draft) => permissions.map(permission => ({
  permission_key: permission.permission_key,
  allowed: Boolean(draft[permission.permission_key]?.allowed),
  scope_type: draft[permission.permission_key]?.scope_type || defaultScopeType(permission.scope_mode),
  store_ids: [...(draft[permission.permission_key]?.store_ids || [])].sort(),
}));

export const enabledPermissionCount = draft => Object.values(draft || {}).filter(item => item.allowed).length;
